import { getConfig } from '@klpkonsern/appconfig';
import { generateRouteWithBase } from '@klp/routing';

export const hostUrl = () =>
    window.location.protocol.concat('//', window.location.host);
export const callbackUrl = (callbackRoute: string) =>
    window.location.protocol.concat('//', window.location.host, callbackRoute);

export const generateApiRoute = (
    routePath: string | Array<string | number | undefined>,
    apiVersion: string = getConfig('WEBAPP_API_VERSION', 'v1'),
): string => generateRouteWithBase(routePath, apiVersion);
